
export class BankPackageEntity {
  id: number;
  corpId: number;
  name: string;
  showInMagnament: boolean;
  currency: string;
}
